module.exports = __webpack_public_path__ + "static/img/icon tj qklb01.57433eeb.svg";